
import * as z from 'zod';

export const profileSchema = z.object({
  fullName: z.string().min(2, { message: 'Full name must be at least 2 characters' }),
  phoneNumber: z.string().optional(),
  companyName: z.string().optional(),
  currentPassword: z.string().optional(),
  newPassword: z.string().min(6, { message: 'Password must be at least 6 characters' }).optional(),
  confirmPassword: z.string().optional(),
  email: z.string().optional(), // Add email field to schema since it's used in the form
}).refine((data) => !data.newPassword || data.newPassword === data.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"],
}).refine((data) => !data.newPassword || data.currentPassword, {
  message: "Current password is required to set a new password",
  path: ["currentPassword"],
});

export type ProfileFormValues = z.infer<typeof profileSchema>;
